import { reportService } from '../request'

/**
 * 获取数据项目列表
 * @param {Object} params 查询参数 {page, size, name?, type?}
 * @returns {Promise} 返回Promise对象
 */
export const listDataProjects = (params) => {
  return reportService.get('/data-projects', { params })
}

/**
 * 获取数据项目详情
 * @param {String} id 项目ID
 * @returns {Promise} 返回Promise对象
 */
export const getDataProject = (id) => {
  return reportService.get(`/data-projects/${id}`)
}

/**
 * 创建数据项目
 * @param {Object} data 项目数据
 * @returns {Promise} 返回Promise对象
 */
export const createDataProject = (data) => {
  return reportService.post('/data-projects', data)
}

/**
 * 更新数据项目
 * @param {String} id 项目ID
 * @param {Object} data 更新数据
 * @returns {Promise} 返回Promise对象
 */
export const updateDataProject = (id, data) => {
  return reportService.put(`/data-projects/${id}`, data)
}

/**
 * 删除数据项目
 * @param {String} id 项目ID
 * @returns {Promise} 返回Promise对象
 */
export const deleteDataProject = (id) => {
  return reportService.delete(`/data-projects/${id}`)
}

/**
 * 切换数据项目状态
 * @param {String} id 项目ID
 * @returns {Promise} 返回Promise对象
 */
/**
 * 切换数据项目状态
 * @param {String} id 项目ID
 * @param {String} status 新状态 ('active'或'inactive')
 * @returns {Promise} 返回Promise对象
 */
export const toggleDataProjectStatus = (id, status) => {
  return reportService.patch(
    `/data-projects/${id}/status`,
    { status },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )
}